module.exports = __webpack_public_path__ + "img/syrian_air.1f418fa7.png";